import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { universalStyles, white } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  pageList: {
    marginBottom: 30,
  },
  whiteText: {
    color: white,
  },
  header: {
    color: white,
    fontSize: 20,
    fontWeight: 900,
  },
}));

const InterpretationPage01 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6">
        This training is designed to help physicians understand the recommended image acquisition and interpretation
        criteria for POSLUMA.
      </Typography>
      <div className={classes.poslumaBox}>
        <Typography className={classes.header}>The Image Interpretation Training contains the following:</Typography>
        <ul className={classNames(classes.poslumaList, classes.whiteText, classes.pageList)}>
          <li>Steps needed for effective identification and interpretation of prostate cancer lesions</li>
          <li>Ungraded questions to provide an engaging learning experience</li>
          <li>
            Narrated clinical case studies, which follow patients from clinical presentation through imaging (including
            videos), and, finally, to image findings
          </li>
        </ul>
        <Typography className={classes.header}>
          We encourage setting aside 60 minutes to complete this training. If you are interrupted or logged out, you
          will be redirected to the last web page you reviewed upon returning to this training track.
          <br />
          <br />
          <i>To gain access to additional materials, please be sure to fully complete this training.</i>
        </Typography>
      </div>
    </>
  );
};

export default InterpretationPage01;
